<template>
  <div>
    <b-row
      :class="'row-container tw-flex tw-flex-row tw-gap-[40px] tw-mr-0 tw-ml-0'"
    >
      <b-col :class="'col-container tw-pr-0 tw-pl-0 tw-flex tw-items-center'">
        <label
          :class="[
            'tw-mb-0 tw-text-[13px] tw-text-[#231F20] tw-leading-[145%] tw-font-medium tw-font-Poppins',
            classTitle,
          ]"
          >{{ title }}</label
        >
        <span v-if="required" class="tw-text-[red]">&nbsp;*</span>
      </b-col>
      <b-col :class="`col-sm-${colInput} tw-pr-0 tw-pl-0`">
        <div :class="`dropdown ${dropdownClass}`">
          <BaseDropDown
            :id="
              'goals-dropdown-wizard-dropdown-' +
              toKebabCase(title) +
              '-' +
              index
            "
            :model-value="curentValue"
            :data="dropdownData"
            :validation="validation || {}"
            :class-name="`gray-dropdown-container tw-h-[56px] ${
              isApiError ? 'is-api-error' : ''
            }`"
            @update:open-dropdown="isDropdownOpen = $event"
            @update:model-value="handleClick"
          >
            <template #button-content>
              <div class="tw-flex tw-justify-between tw-items-center">
                <span
                  :class="`tw-text-[13px] ${
                    curentValue ? 'tw-text-[#000]' : 'tw-text-[#B7B7B7]'
                  }  tw-leading-[100%] tw-font-normal tw-font-Poppins`"
                >
                  {{ curentValue ? curentValue : placeholder }}
                </span>
                <svg
                  :class="`right-icon-arrow ${
                    isDropdownOpen ? 'tw-rotate-180' : ''
                  }`"
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="7"
                  viewBox="0 0 10 7"
                  fill="none"
                >
                  <path
                    d="M0.104884 1.50643L4.67976 6.69267C4.72096 6.73622 4.77061 6.7709 4.82567 6.79461C4.88073 6.81832 4.94005 6.83054 5 6.83054C5.05995 6.83054 5.11927 6.81832 5.17433 6.79461C5.22939 6.7709 5.27904 6.73622 5.32024 6.69267L9.89512 1.50643C9.93169 1.46523 9.95972 1.41717 9.97757 1.36506C9.99541 1.31294 10.0027 1.25779 9.99909 1.20282C9.99458 1.14741 9.97901 1.09346 9.95329 1.04417C9.92758 0.994883 9.89224 0.951249 9.84937 0.915852L9.07996 0.27121C9.03793 0.234855 8.98904 0.207291 8.93618 0.190147C8.88332 0.173003 8.82756 0.166627 8.77219 0.171394C8.71709 0.175381 8.66333 0.190306 8.61406 0.215299C8.56479 0.240292 8.52099 0.274851 8.48522 0.316959L5.0707 4.24719C5.04968 4.26802 5.02128 4.2797 4.99168 4.2797C4.96209 4.2797 4.93369 4.26802 4.91266 4.24719L1.51478 0.316958C1.44755 0.236653 1.35249 0.18467 1.2486 0.171394C1.19352 0.16606 1.13793 0.171774 1.08508 0.1882C1.03223 0.204625 0.983193 0.231432 0.940838 0.267051L0.150633 0.915852C0.107763 0.951249 0.0724248 0.994883 0.0467083 1.04417C0.0209918 1.09346 0.0054186 1.14741 0.000909419 1.20282C-0.00273159 1.25779 0.00458484 1.31294 0.0224338 1.36506C0.0402828 1.41717 0.0683087 1.46523 0.104884 1.50643Z"
                    fill="#387DFF"
                  />
                </svg>
              </div>
            </template>
          </BaseDropDown>
        </div>
      </b-col>
    </b-row>
    <b-row class="align-items-center">
      <b-col :class="'col-container tw-pr-0 tw-pl-0 tw-flex tw-items-center'" />
      <b-col :class="'col-sm-6 tw-pr-0 tw-pl-0'">
        <slot name="feedback">
          <b-form-invalid-feedback
            :class="{ 'is-invalid': validation?.$error }"
          >
            <VRuntimeTemplate :template="validation?.$errors?.[0]?.$message" />
          </b-form-invalid-feedback>
        </slot>
      </b-col>
    </b-row>
  </div>
</template>
<script setup lang="ts">
import { ref } from "vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import { PropType } from "vue";
import BaseDropDown from "../common/form/baseDropDown.vue";
import VRuntimeTemplate from "vue3-runtime-template";

const props = defineProps({
  title: { type: String, required: true },
  classTitle: { type: String, required: false, default: "" },
  placeholder: { type: String, required: true },
  dropdownData: {
    type: Array as PropType<IDropDownData[]>,
    required: false,
    default: () => [],
  },
  required: { type: Boolean, required: false, default: false },
  currentType: { type: Object, required: false, default: () => {} },
  typeId: { type: String, required: false, default: null },
  validation: { type: Object, required: false, default: null },
  index: { type: Number, required: false, default: 0 },
  colInput: { type: Number, required: false, default: 6 },
  dropdownClass: { type: String, required: false, default: "" },
  isApiError: { type: Boolean, required: false, default: false },
});

const curentValue = ref(props.currentType?.name || null);
const isDropdownOpen = ref(false);
const emit = defineEmits(["update:modelValue"]);

const handleClick = (dataId, data) => {
  curentValue.value = data.name;
  emit("update:modelValue", data);
};

const toKebabCase = (str) => {
  return str
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");
};
</script>

<style lang="scss" scoped>
.invalid-feedback {
  font-size: 11px !important;
  font-family: Poppins !important;
  font-style: normal !important;
  font-weight: 500 !important;
  color: #f7553c !important;
  line-height: 130% !important;
  margin-top: 10px !important;
}

.was-validated .input-base-form-input:invalid,
.input-base-form-input.is-invalid {
  border: 1px solid #f7553c;
  background: #fee5e2;

  &::after {
    content: "";
  }
}

.is-invalid {
  display: block !important;
}
@media screen and (max-width: 600px) {
  .row-container {
    flex-direction: column;
    gap: 20px;

    .col-sm-6 {
      max-width: 100%;
    }
  }
}
</style>
